import { IconButton, Tooltip } from '@chakra-ui/react'
import { generatePath } from 'react-router'
import { Print } from 'src/components/icon/generated'
import { Paths } from 'src/constants/paths'
import { useCurrentMember } from 'src/features/auth/context'
import { openNewWindow } from 'src/utils/openNewWindow'

import { WorksheetDetail } from '../../types'
import { canPrintWorksheet } from '../../utils/permissions'

type Props = {
  worksheet: WorksheetDetail
}

export const PrintWorksheetButton: React.FC<Props> = ({ worksheet }) => {
  const { currentMember } = useCurrentMember()

  // 権限チェック: Dr・CRCのみ、保存済みのみ
  if (!canPrintWorksheet(currentMember.role, worksheet.status)) {
    return null
  }

  const handlePrint = () => {
    const url = generatePath(Paths.WorksheetPrint, {
      worksheetUid: worksheet.uid,
    })
    openNewWindow(url, 'newWindow')
  }

  return (
    <Tooltip label="印刷" placement="bottom">
      <IconButton
        aria-label="印刷"
        icon={<Print size="lg" />}
        variant="customIconButtonGhost"
        onClick={handlePrint}
      />
    </Tooltip>
  )
}
